module.exports = __webpack_public_path__ + "img/00024.c2476316.webp";